import React, { useState, useRef } from "react";
import { useLocation } from "react-router";
import { useTheme } from "../../context/ThemeProvider";
import { Button } from "../ui";
import { NavMenu } from "@/components/common/NavMenu";
import { NavLogo } from "@/components/common/NavLogo";
import { Moon, Sun } from "lucide-react";
import { LayoutContainer } from "../common/LayoutContainer";

export const Navbar = () => {
  const [show, setShow] = useState(false);
  const { setTheme, theme } = useTheme();
  const containerRef = useRef(null);

  const toggleMenu = () => {
    setShow(!show);
  };

  return (
    <>
      <nav className="h-[12vh] border-b border-gray-200 dark:border-gray-800 flex justify-center">
        <LayoutContainer className="flex-1 sm:flex-none">
          <NavLogo />
          {/* <ToggelMenuBtn show={show} toggleMenu={toggleMenu} theme={theme} /> */}
          <NavMenu
            show={show}
            toggleMenu={toggleMenu}
            containerRef={containerRef}
            theme={theme}
          />
          <Button
            onClick={() => setTheme(theme === "light" ? "dark" : "light")}
            variant="ghost"
            className="hover:bg-transparent"
          >
            {theme === "dark" ? (
              <Sun className="h-8 w-8" />
            ) : (
              <Moon className="h-8 w-8" />
            )}
          </Button>
        </LayoutContainer>
      </nav>
      <div
        className={`fixed top-0 left-0 h-screen w-1/4 bg-primary transition-transform duration-200 ease-linear z-20 
        ${show ? "translate-x-0" : "-translate-x-full"}`}
      />
      <div
        className={`fixed top-0 right-0 h-screen w-1/4 bg-primary transition-transform duration-200 ease-linear z-20 
        ${show ? "translate-x-0" : "translate-x-full"}`}
      />
    </>
  );
};

const ToggelMenuBtn = ({ show, toggleMenu, theme }) => {
  return (
    <button
      className="hidden md:block relative z-40 h-[50px] cursor-pointer outline-none border-transparent bg-transparent"
      onClick={toggleMenu}
    >
      <span
        className={`block w-10 h-[5px] my-1.5 rounded-lg transition-all duration-600 shadow-md
        ${show ? "translate-y-3 rotate-45" : ""}`}
      />
      <span
        className={`block w-10 h-[5px] my-1.5 rounded-lg transition-all duration-600
        ${show ? "bg-transparent shadow-none -translate-x-14" : ""}`}
      />
      <span
        className={`block w-10 h-[5px] my-1.5 rounded-lg transition-all duration-600 shadow-md
        ${show ? "-translate-y-3 -rotate-45" : ""}`}
      />
    </button>
  );
};
